/* Created by Chintan on 30/8/16.
 */
'use strict';

export default class LogoutController {
	constructor(UserLoginService,$state){
		UserLoginService.logOut().then(function(result){
			$state.go('login');
		}, function(err){
			if(err){
			}
		});
	}
}


// WEBPACK FOOTER //
// ./src/app/modules/dashboard/logout.controller.js